/**
 * JWT 存放（瀏覽器 localStorage）。純函式、無框架依賴，SSR（`window` 不存在）時安全降級為 no-op。
 */

const TOKEN_STORAGE_KEY = "ccheng_admin_token";

function hasLocalStorage(): boolean {
  try {
    return typeof window !== "undefined" && !!window.localStorage;
  } catch {
    // 某些瀏覽器隱私模式 / 沙盒環境存取 localStorage 會直接 throw。
    return false;
  }
}

export function getToken(): string | null {
  if (!hasLocalStorage()) return null;
  try {
    return window.localStorage.getItem(TOKEN_STORAGE_KEY);
  } catch {
    return null;
  }
}

export function setToken(token: string): void {
  if (!hasLocalStorage()) return;
  try {
    window.localStorage.setItem(TOKEN_STORAGE_KEY, token);
  } catch {
    // 忽略寫入失敗（例如私密瀏覽模式的儲存配額）。
  }
}

export function clearToken(): void {
  if (!hasLocalStorage()) return;
  try {
    window.localStorage.removeItem(TOKEN_STORAGE_KEY);
  } catch {
    // 忽略。
  }
}
